import { memo, useCallback } from "react";

import { DesignerMode } from "../types";
import ErrorBoundary from "../../widgets/ErrorBoundary";
import { IControlBaseAttributes } from "../../base/models";
import { Registry } from "../../base/register";
import { useDesignContext } from "../../providers";
import { useGetPropertyValues } from "../../base/hooks/bound-properties/useGetPropertyValues";

export const PageControl = memo((attrs: IControlBaseAttributes) => {
    const { control, additionalProps, className, orientation, children, onDesignChange } = attrs;
    const props = useGetPropertyValues(control.bindings);
    const { control: { designerMode } } = useDesignContext()

    const getControl = useCallback(() => {
        const { componentType } = control;
        const item = Registry.getControlByType(componentType);
        if (!item) {
            return <div className="alert alert-warning d-flex gap-3">
                <span className="badge badge-warning">
                    {control.componentType}
                </span>
                <span className="badge badge-warning">
                    {control.componentName}
                </span>
                not implemented
            </div>
        }

        const component = designerMode === DesignerMode.Draft ?
            (item.draftComponent || item.component) : item.component;

        return <>{component({
            control,
            additionalProps,
            className,
            orientation,
            children,
            props,
            designerMode,
            onDesignChange,
        })}</>
        // eslint-disable-next-line
    }, [control, props, additionalProps])

    return <>
        <ErrorBoundary>
            {getControl()}
        </ErrorBoundary>
    </>
})